import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupInfoModule } from '@src/app/modules/group-info';

import { GroupInfoTelegramComponent } from './group-info-telegram.component';

@NgModule({
  declarations: [GroupInfoTelegramComponent],
  imports: [CommonModule, GroupInfoModule],
  exports: [GroupInfoTelegramComponent],
})
export class GroupInfoTelegramModule {}
